export const footerData = {
    hideSideBlockLeft: 'hideSideBlockLeft',
    hideSideBlockRight: 'hideSideBlockRight',
    hideActionButtons: 'hideActionButtons',
    showInfoBlock: 'showInfoBlock',
    info: 'info',
    infoTooltip: 'infoTooltip',
} as const;

export type TFooterData = (typeof footerData)[keyof typeof footerData];

export interface IFooterData {
    [footerData.hideSideBlockLeft]?: boolean | null;
    [footerData.hideSideBlockRight]?: boolean | null;
    [footerData.hideActionButtons]?: boolean | null;
    [footerData.showInfoBlock]?: boolean | null;
    [footerData.info]?: string | null;
    // Detail (bv. commit/branch) achter een tooltip op het info-blok — zie footer.component.html.
    [footerData.infoTooltip]?: string | null;
}

export class FooterData
    implements IFooterData
{
    [footerData.hideSideBlockLeft]?: boolean | null =  true;
    [footerData.hideSideBlockRight]?: boolean | null =  false;
    [footerData.hideActionButtons]?: boolean | null =  false;
    [footerData.showInfoBlock]?: boolean | null =  false;
    [footerData.info]?: string | null =  '';
    [footerData.infoTooltip]?: string | null =  '';

    constructor(data?: IFooterData) {
        this[footerData.hideSideBlockLeft] = data?.hideSideBlockLeft;
        this[footerData.hideSideBlockRight] = data?.hideSideBlockRight;
        this[footerData.hideActionButtons] = data?.hideActionButtons;
        this[footerData.showInfoBlock] = data?.showInfoBlock;
        this[footerData.info] = data?.info;
        this[footerData.infoTooltip] = data?.infoTooltip;
    }
}
